<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.type === 'edit' ? $t('scope.text_710') : $t('common.action.create') }}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('report.origin_resource_type')">
          {{ params.originResourceType.name }}
        </a-form-model-item>
        <a-form-model-item :label="$t('report.parent_resource_type')" prop="parent_id">
          <base-select
            v-model="form.parent_id"
            resource="ext_resource_types"
            :params="resourceTypeParams"
            :select-props="{ placeholder: $t('common.tips.select', [$t('report.parent_resource_type')]) }" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'ResourceTypeAssociateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { parent_id = undefined } = this.params.originResourceType || {}
    return {
      loading: false,
      form: {
        parent_id,
      },
      rules: {
        parent_id: [{ required: true, message: this.$t('common.tips.select', [this.$t('report.parent_resource_type')]) }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      resourceTypeParams: {
        limit: 20,
        filter: `id.notin(${this.params.originResourceType.id})`,
      },
    }
  },
  computed: {},
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await new this.$Manager('ext_resource_types', 'v1').update({
          id: this.params.originResourceType.id,
          data: this.form,
        })
        this.params.ok && this.params.ok()
        this.cancelDialog()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
